import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareMinus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconSquareMinus"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75ZM15.25 12.7502C15.6642 12.7502 16 12.4144 16 12.0002C16 11.586 15.6642 11.2502 15.25 11.2502H8.75736C8.34314 11.2502 8.00736 11.586 8.00736 12.0002C8.00736 12.4144 8.34314 12.7502 8.75736 12.7502H15.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareMinus;
